import { backgroundThemes, paddingSizes } from '../constants/contentfulStyle.constant'
import palette from '../styles/palette'

export const setPaddingSize = (
  paddingName: string,
  defaultSize: number = paddingSizes.NONE.size
) => {
  let paddingSize = defaultSize

  switch (paddingName) {
    case paddingSizes.SMALL.name:
      paddingSize = paddingSizes.SMALL.size
      break
    case paddingSizes.LARGE.name:
      paddingSize = paddingSizes.LARGE.size
      break
    default:
      paddingSize = paddingSizes.NONE.size
  }

  return paddingSize
}

export const setBackgroundTheme = (
  theme: string,
  defaultColor: string = palette.background.white
) => {
  let themeColor = defaultColor

  switch (theme) {
    case backgroundThemes.DARK:
      themeColor = palette.background.dark
      break
    case backgroundThemes.GRAY:
      themeColor = palette.background.gray
      break
    default:
      themeColor = palette.background.white
  }

  return themeColor
}
